<template>
  <!-- Container (About Section) -->
  <div class="w3-content w3-container w3-padding-64" id="about">
    <h3 class="w3-center">ABOUT US</h3>
    <!--<p class="w3-center">
      <em>{{ explain[0].des }}</em>
    </p>-->
    <p>{{ explain[1].des }}</p>

    <!-- Responsive Grid. Four columns on tablets, laptops and desktops. Will stack on mobile devices/small screens (100% width) -->
    <div class="w3-row-padding w3-center">
      <div class="w3-col m3">
        <p style="margin: 20px 0px 0px 0px">
          <strong>{{ explain[2].title }}</strong>
        </p>
        <p>
          <strong>{{ photos[0].access }}</strong>
        </p>
        <div class="my_containter">
          <img
            :src="photos[0].photo"
            class="w3-round w3-image"
            alt="Photo of Me"
            width="500"
            height="333"
          />
        </div>
      </div>
      <div class="w3-col m3">
        <p style="margin: 20px 0px 0px 0px">
          <strong>{{ explain[3].title }}</strong>
        </p>
        <p>
          <strong>{{ photos[1].access }}</strong>
        </p>
        <img
          :src="photos[1].photo"
          class="w3-round w3-image"
          alt="Photo of Me"
          width="500"
          height="333"
        />
      </div>
      <div class="w3-col m3">
        <p style="margin: 20px 0px 0px 0px">
          <strong>{{ explain[4].title }}</strong>
        </p>
        <p>
          <strong>{{ photos[2].access }}</strong>
        </p>
        <img
          :src="photos[2].photo"
          class="w3-round w3-image"
          alt="Photo of Me"
          width="500"
          height="333"
        />
      </div>
      <div class="w3-col m3">
        <p style="margin: 20px 0px 0px 0px">
          <strong>{{ explain[5].title }}</strong>
        </p>
        <p>
          <strong>{{ photos[3].access }}</strong>
        </p>
        <img
          :src="photos[3].photo"
          class="w3-round w3-image"
          alt="Photo of Me"
          width="500"
          height="333"
        />
      </div>
      <div class="w3-col m3">
        <p style="margin: 20px 0px 0px 0px">
          <strong>{{ explain[6].title }}</strong>
        </p>
        <p>
          <strong>{{ photos[4].access }}</strong>
        </p>
        <img
          :src="photos[4].photo"
          class="w3-round w3-image"
          alt="Photo of Me"
          width="500"
          height="333"
        />
      </div>
      <div class="w3-col m3">
        <p style="margin: 20px 0px 0px 0px">
          <strong>{{ explain[7].title }}</strong>
        </p>
        <p>
          <strong>{{ photos[5].access }}</strong>
        </p>
        <img
          :src="photos[5].photo"
          class="w3-round w3-image"
          alt="Photo of Me"
          width="500"
          height="333"
        />
      </div>
      <div class="w3-col m3">
        <p style="margin: 20px 0px 0px 0px">
          <strong>{{ explain[8].title }}</strong>
        </p>
        <p>
          <strong>{{ photos[6].access }}</strong>
        </p>
        <img
          :src="photos[6].photo"
          class="w3-round w3-image"
          alt="Photo of Me"
          width="500"
          height="333"
        />
      </div>
      <div class="w3-col m3">
        <p style="margin: 20px 0px 0px 0px">
          <strong>{{ explain[9].title }}</strong>
        </p>
        <p>
          <strong>{{ photos[7].access }}</strong>
        </p>
        <img
          :src="photos[7].photo"
          class="w3-round w3-image"
          alt="Photo of Me"
          width="500"
          height="333"
        />
      </div>

      <!-- next  -->
      <div class="w3-row-padding w3-center">
        <div class="w3-col m3">
          <p style="margin: 20px 0px 0px 0px">
            <strong>{{ explain[10].title }}</strong>
          </p>
          <p>
            <strong>{{ photos[8].access }}</strong>
          </p>
          <img
            :src="photos[8].photo"
            class="w3-round w3-image"
            alt="Photo of Me"
            width="500"
            height="333"
          />
        </div>
        <div class="w3-col m3">
          <p style="margin: 20px 0px 0px 0px">
            <strong>{{ explain[11].title }}</strong>
          </p>
          <p>
            <strong>{{ photos[9].access }}</strong>
          </p>
          <img
            :src="photos[9].photo"
            class="w3-round w3-image"
            alt="Photo of Me"
            width="500"
            height="333"
          />
        </div>
        <div class="w3-col m3">
          <p style="margin: 20px 0px 0px 0px">
            <strong>{{ explain[12].title }}</strong>
          </p>
          <p>
            <strong>{{ photos[10].access }}</strong>
          </p>
          <img
            :src="photos[10].photo"
            class="w3-round w3-image"
            alt="Photo of Me"
            width="500"
            height="333"
          />
        </div>
        <div class="w3-col m3">
          <p style="margin: 20px 0px 0px 0px">
            <strong>{{ explain[13].title }}</strong>
          </p>
          <p>
            <strong>{{ photos[11].access }}</strong>
          </p>
          <img
            :src="photos[11].photo"
            class="w3-round w3-image"
            alt="Photo of Me"
            width="500"
            height="333"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { language_util } from "@/classes/language/language_util.js";
import { about } from "@/classes/about/about.js";
import { computed } from "vue";
export default {
  components: {},
  setup() {
    const my_language = computed(() => language_util.get_language());
    const size = computed(() => explain.value.length);

    const explain = computed(() => about.get_all(my_language.value));
    const photos = computed(() => {
      let temp = about.get_photos()
      let i, o_array = []
      for (i=0; i<temp.length; i++) {
        let temp2 = process(temp[i])
        o_array.push ( {access: temp2, photo: temp[i].photo})
      }
      return o_array
    });

    function process(myitem) {
      switch(my_language.value) {
        case 'en': return myitem.access.en;
        case 'jp': return myitem.access.jp;
        case 'kr': return myitem.access.kr;
        case 'cn': return myitem.access.cn;
      }
    }

    return {
      size,
      explain,
      photos,
    };
  },
};
</script>

<style scoped>
.text-block {
  position: absolute;
  bottom: 20px;
  right: 20px;
  background-color: black;
  color: white;
  padding-left: 20px;
  padding-right: 20px;
}
.my_containter {
  position: relative;
  font-family: Arial;
}
</style>